<template>
  <el-dialog class="dialog-goods-container" fullscreen @close="handleClose" title="商品设置" :visible.sync="dialogVisible">
    <div class="v-goods" v-loading="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="商品名称" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="封面图片" prop="coverimg">
            <!-- <div class="pmp-container">
              <div class="pmp-img" v-if="ruleForm.coverimg">
                <div class="img-content" :style="{ backgroundImage: 'url(' + ruleForm.coverimg + ')' }"></div>
                <div class="pmp-cover">
                  <div class="vl-c">
                    <i class="el-icon-view" @click.stop="$preview.showImg(ruleForm.coverimg)"></i>
                    <i class="el-icon-delete" @click.stop="onRemove"></i>
                  </div>
                </div>
              </div>
              <Button v-else v-loading="imgLoading" @click="onImgCutter" class="pmp-img-btn">
                <i class="el-icon-plus" style="font-size: 20px;"></i>
                <p>上传图片</p>
              </Button>
            </div> -->
            <div class="pmp-container">
              <div class="pmp-img" v-if="ruleForm.coverimg">
                <div class="img-content" :style="{ backgroundImage: 'url(' + ruleForm.coverimg + ')' }"></div>
                <div class="pmp-cover">
                  <div class="vl-c">
                    <i class="el-icon-delete" @click.stop="onRemove"></i>
                  </div>
                </div>
              </div>
              <el-upload v-else  v-loading="imgLoading" action="/api/Admin/Points/imgUpload" :http-request="uploadImage"  name="content" class="pmp-img-btn" :show-file-list="false">
                <i class="el-icon-plus" style="font-size: 20px;margin-top: 12px;"></i>
                <div class="text">上传图片</div>
              </el-upload>
            </div>
        </el-form-item>
        <el-form-item label="详情图片" prop="mainimg">
            <div class="pmp-container">
              <div class="pmp-img" v-if="ruleForm.mainimg">
                <div class="img-content" :style="{ backgroundImage: 'url(' + ruleForm.mainimg + ')' }"></div>
                <div class="pmp-cover">
                  <div class="vl-c">
                    <i class="el-icon-delete" @click.stop="onRemoveMainimg"></i>
                  </div>
                </div>
              </div>
              <el-upload v-else  v-loading="mainimgLoading" action="/api/Admin/Points/imgUpload" :http-request="uploadMainimg"  name="content" class="pmp-img-btn" :show-file-list="false">
                <i class="el-icon-plus" style="font-size: 20px;margin-top: 12px;"></i>
                <div class="text">上传图片</div>
              </el-upload>
            </div>
        </el-form-item>
        <el-form-item label="所需积分" prop="needpoints">
          <el-input v-model="ruleForm.needpoints"></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input v-model="ruleForm.stock"></el-input>
        </el-form-item>
        <!-- <el-form-item label="已兑换次数" prop="exchanged">
          <el-input v-model="ruleForm.exchanged"></el-input>
        </el-form-item> -->
        <el-form-item label="商品状态" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio label="1">上架</el-radio>
            <el-radio label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期类型" prop="expiretype">
          <el-radio-group v-model="ruleForm.expiretype">
            <el-radio label="1">计天</el-radio>
            <el-radio label="2">计月</el-radio>
            <el-radio label="3">当月</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期时长" prop="expire" v-if="ruleForm.expiretype !=='3'">
          <el-input type="number" v-model="ruleForm.expire"></el-input>
          <p>有效期时长，单位{{ruleForm.expiretype === '2' ? '月' : '天'}}，大于等于0的值，0表示永久有效</p>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="number" v-model="ruleForm.listorder"></el-input>
        </el-form-item>
        <el-form-item label="兑换须知" prop="description">
          <el-input type="textarea" :rows="6" v-model="ruleForm.description"></el-input>
        </el-form-item>
        <el-form-item label="商品详情">
            <tinymce-editor ref="tinymce" v-model="ruleForm.content"></tinymce-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
 <!--   <ImgCutter ref="headCutterModal" @error="headCatchError" @cutDown="headCutDown">
      <span slot="open"></span>
    </ImgCutter> -->
  </el-dialog>
</template>

<script>
import { goodsAdd, goodsEdit, imgUpload, goodsInfoApi } from '@/views/webpc/CreditMall/GoodsApp/apis'
// import ImgCutter from '@/components/webpc/ImgCutter'
import TinymceEditor from '@/components/webpc/TinymceEditor'
export default {
  components: { TinymceEditor },
  data () {
    return {
      loading: false,
      imgLoading: false,
      mainimgLoading: false,
      dialogVisible: false,
      goodsInfo: null,
      ruleForm: {
        title: '',
        coverimg: '',
        mainimg: '',
        needpoints: '',
        stock: '999999',
        exchanged: '',
        status: '1',
        expiretype: '1',
        expire: null,
        listorder: 100,
        description: '',
        content: ''
      },
      rules: {
        title: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        coverimg: [{ required: true, message: '请上传封面图片', trigger: 'blur' }],
        mainimg: [{ required: true, message: '请上传详情图片', trigger: 'blur' }],
        needpoints: [{ required: true, message: '请输入商品所需积分', trigger: 'blur' }],
        expire: [{ required: true, message: '请输入有效期时长', trigger: 'blur' }],
        status: [
          { required: true, message: '请选择商品状态', trigger: 'change' }
        ],
        expiretype: [
          { required: true, message: '请选择有效期类型', trigger: 'change' }
        ],
        description: [
          { required: true, message: '请输入兑换须知', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getGoods()
        } else {
          return false
        }
      })
    },
    async getGoods () {
      this.loading = true
      let data = new FormData()
      data.append('title', this.ruleForm.title)
      data.append('coverimg', this.ruleForm.coverimg)
      data.append('mainimg', this.ruleForm.mainimg)
      data.append('needpoints', this.ruleForm.needpoints)
      data.append('stock', this.ruleForm.stock)
      data.append('exchanged', this.ruleForm.exchanged)
      data.append('status', this.ruleForm.status)
      data.append('expiretype', this.ruleForm.expiretype)
      if (this.ruleForm.expiretype !== '3') {
        data.append('expire', this.ruleForm.expire)
      }
      data.append('listorder', this.ruleForm.listorder)
      data.append('description', this.ruleForm.description)
      data.append('content', this.ruleForm.content)
      if (this.goodsInfo) {
        data.append('id', this.goodsInfo.id)
        goodsEdit(data)
          .then((result) => {
            if (result) {
              this.loading = false
              this.$message({
                type: 'success',
                message: '保存成功!'
              })
              this.$emit('ok')
              this.dialogVisible = false
            }
          })
          .catch((error) => {
            if (error) {
              this.loading = false
              this.$message({
                type: 'error',
                message: '保存失败!'
              })
            }
          })
      } else {
        goodsAdd(data)
          .then((result) => {
            if (result) {
              this.loading = false
              this.$message({
                type: 'success',
                message: '保存成功!'
              })
              this.$emit('ok')
              this.dialogVisible = false
            }
          })
          .catch((error) => {
            if (error) {
              this.loading = false
              this.$message({
                type: 'error',
                message: '保存失败!'
              })
            }
          })
      }
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.ruleForm.content = ''
    },
    goodsDetails () {
      this.loading = true
      let data = new FormData()
      data.append('id', this.goodsInfo.id)
      goodsInfoApi(data)
        .then((result) => {
          if (result) {
            this.loading = false
            this.ruleForm.title = result.data.title
            this.ruleForm.coverimg = result.data.coverimg
            this.ruleForm.mainimg = result.data.mainimg
            this.ruleForm.needpoints = result.data.needpoints
            this.ruleForm.stock = result.data.stock
            this.ruleForm.exchanged = result.data.exchanged
            this.ruleForm.status = result.data.status
            this.ruleForm.expiretype = result.data.expiretype
            this.ruleForm.expire = result.data.expire
            this.ruleForm.listorder = result.data.listorder
            this.ruleForm.description = result.data.description
            this.ruleForm.content = result.data.content
          }
        })
        .catch((error) => {
          if (error) {
            this.loading = false
          }
        })
    },
    show (obj) {
      if (obj) {
        this.goodsInfo = obj
        this.goodsDetails()
      } else {
        this.goodsInfo = ''
        this.ruleForm.title = ''
        this.ruleForm.coverimg = ''
        this.ruleForm.mainimg = ''
        this.ruleForm.needpoints = ''
        this.ruleForm.stock = '999999'
        this.ruleForm.exchanged = ''
        this.ruleForm.status = '1'
        this.ruleForm.expiretype = '1'
        this.ruleForm.expire = null
        this.ruleForm.listorder = '100'
        this.ruleForm.description = ''
        this.ruleForm.content = ''
      }
      this.dialogVisible = true
    },
    handleClose () {
      setTimeout(() => {
        this.tableData = []
        this.goodsInfo = null
      }, 200)
      this.dialogVisible = false
    },
    onRemove () {
      this.ruleForm.coverimg = ''
    },
    onRemoveMainimg () {
      this.ruleForm.mainimg = ''
    },
    // onImgCutter () {
    //   this.$refs.headCutterModal.handleOpen()
    // },
    // headCutDown (res) {
    // let blobFile = new window.File([res.blob], res.file.name, { type: res.file.type })
    // this.uploadImage(blobFile)
    // this.uploadImage(res.dataURL)
    // },
    // headCatchError (res) {
    //   console.log(res)
    //   window.alert(res.msg)
    // },
    async uploadImage (file) {
      let base64Str = await this.getBase64(file.file)
      this.imgLoading = true
      let data = new FormData()
      data.append('content', base64Str)
      imgUpload(data)
        .then((result) => {
          if (result) {
            this.imgLoading = false
            this.ruleForm.coverimg = result.data.file_path
            this.$refs['ruleForm'].validateField('coverimg')
            this.$message({
              type: 'success',
              message: '上传成功!'
            })
          }
        })
        .catch((error) => {
          if (error) {
            this.imgLoading = false
            this.$message({
              type: 'error',
              message: '上传失败!'
            })
          }
        })
    },
    async uploadMainimg (file) {
      let base64Str = await this.getBase64(file.file)
      this.mainimgLoading = true
      let data = new FormData()
      data.append('content', base64Str)
      imgUpload(data)
        .then((result) => {
          if (result) {
            this.mainimgLoading = false
            this.ruleForm.mainimg = result.data.file_path
            this.$refs['ruleForm'].validateField('mainimg')
            this.$message({
              type: 'success',
              message: '上传成功!'
            })
          }
        })
        .catch((error) => {
          if (error) {
            this.mainimgLoading = false
            this.$message({
              type: 'error',
              message: '上传失败!'
            })
          }
        })
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
//裁剪图片样式
.pmp-container {
    width: 72px;
    height: 72px;
    &.mid {
        width: 98px;
        height: 98px;
    }
    &.big {
        width: 104px;
        height: 104px;
    }
    .pmp-img {
        display: inline-block;
        text-align: center;
        width: 100%;
        height: 100%;
        line-height: 1px;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        // box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
        .img-content {
            width: 100%;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
        }
        img {
            width: 100%;
            height: 100%;
        }
        &:hover {
            .pmp-cover {
                display: block;
            }
        }
        .pmp-cover {
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.6);
            i {
                color: #fff;
                font-size: 20px;
                cursor: pointer;
                margin: 0 2px;
            }
        }
    }
    .pmp-img-btn {
        width: 100%;
        height: 100%;
        // border-style: dashed;
        // border-color: #ddd;
        color: rgb(153, 153, 153);
        padding: 0;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box
    }
    .text{
      height: 24px;
      line-height: 12px;
    }
    /deep/ .el-upload {
      width: 100%;
      height: 100%;
    }
}
.tinymce-editor{
    border-radius: 4px !important;
    border: 1px solid #DCDFE6;
    z-index: 1000;
}
//垂直居中
.vl-c {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/webpc/CreditMall/GoodsApp/modules/GoodsModal.vue